import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const projects = [{
  id: 1,
  title: "Flächenreinigung",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/surface_cleaning_before_without_chemicals.png",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/surface_cleaning_after_without_chemicals.png",
  description: "Professionelle Reinigung ohne chemische Zusätze"
}, {
  id: 2,
  title: "Hausmeisterservice",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/caretaker_service_before_maintenance.png",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/caretaker_service_after_maintenance.png",
  description: "Zuverlässige Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich"
}, {
  id: 3,
  title: "Gartenpflege",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/garden_care_before_maintenance.png",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/garden_care_after_maintenance.png",
  description: "Professionelle Pflege für gepflegte Außenanlagen"
}, {
  id: 4,
  title: "Büroorganisation",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_before_support.png",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_after_support.png",
  description: "Bürotätigkeiten und Hilfeleistungen im Bereich Organisation"
}];
export default function BeforeAfterGallery() {
  return <section className="bg-background py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 opacity-0 animate-fade-in-up">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Unsere Leistungen im Überblick
          </h2>
          <p className="text-muted-foreground text-base lg:text-lg max-w-2xl mx-auto">
            Von Flächenreinigung über Hausmeisterservice bis zu Gartenpflege und Büroorganisation – überzeugen Sie sich von der Qualität unserer Arbeit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {projects.map((project, i) => <Card key={project.id} data-index={i} className="opacity-0 animate-fade-in-up border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 bg-muted-light" style={{
          animationDelay: `${i * 100}ms`
        }}>
              <CardHeader className="px-6">
                <CardTitle className="text-xl font-semibold text-foreground">
                  {project.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-6 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <p className="text-sm font-medium text-muted-foreground">Vorher</p>
                    <div className="relative aspect-square rounded-lg overflow-hidden border border-border">
                      <img src={project.beforeImage} alt={`${project.title} vorher`} className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <p className="text-sm font-medium text-primary">Nachher</p>
                    <div className="relative aspect-square rounded-lg overflow-hidden border border-primary/30 ring-2 ring-primary/20">
                      <img src={project.afterImage} alt={`${project.title} nachher`} className="w-full h-full object-cover" />
                    </div>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground pt-2">
                  {project.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}